// --------------------------------------------------------------------------
// relativeTime.js
// --------------------------------------------------------------------------
// Uses moment.js to display relative time
// --------------------------------------------------------------------------

EC.relativeTime = function() {

    'use strict';

    function init() {
        $('.js-relative-time').each(relativeTime);
    }

    function relativeTime(){
        var absoluteTime = this.getAttribute('datetime'),
            relativeTime = moment(absoluteTime).fromNow(),
            humanReadable = moment(absoluteTime).format("dddd, MMMM Do YYYY, h:mm a");

        this.textContent = relativeTime;
        this.title = humanReadable;
    }

    return {
        init: init
    };

}();